export class PatientDairyModel{
    "patientId":String;
    "studyId":Number;
    "fromDate":Number;
    "toDate":Number;
    "userId":Number;
}